/* ==========================================================================
   ProductCardLeiRxjs > Client > nav
   ========================================================================== */
const Button = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/client/js');

/* Init nav */
function initNav(instance) {
    const nav = instance;
    const { selector, element } = instance;
    nav.navItems = [...element.querySelectorAll(`[data-component="ButtonRxjs"]`)].map(item => {
        const type = item.dataset.type || false;
        return Button(`${selector} [data-component="ButtonRxjs"][data-type="${type}"]`);
    });

    if (nav.navItems.length > 0)
        /* Update subscriptions */
        nav.subscriptions = {
            ...nav.subscriptions,
            ...nav.navItems
                .map((button, ind) => ({
                    [`navItemClick${ind}`]: button.events.click$.subscribe(event => {
                        event.stopPropagation();
                        /* Data */
                        const { active } = nav.store.select('card');

                        if (active !== ind) {
                            nav.actions.activeTab(ind);
                            nav.actions.disableTab(active);
                        }
                    })
                }))
                .reduce((acc, val) => ({ ...acc, ...val }))
        };
}

/* Exports */
module.exports = {
    initNav
};
